import { useFormContext } from "react-hook-form";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import SelectMUI from "@mui/material/Select";
import Switch from "../../../Form/Switch";
import { useTranslationApp } from "../../../../lib/i18next";
import { INPUT_COLOR_BORDER } from "../../../../utils/colors";
import {
  META_ATTRIBUTION_ENGAGED_VIEW_LABEL,
  META_ATTRIBUTION_WINDOW_DEFAULT_OPTION,
  META_ATTRIBUTION_WINDOW_DESCRIPTION,
} from "../../../../i18n/keysTranslations";
import {
  META_ATTRIBUTION_WINDOW_DEFAULT,
  META_ATTRIBUTION_WINDOW_OPTIONS,
  getIsValidMetaAttributionWindow,
} from "../../../../utils/metaAttribution";

const AttributionWindowMeta = ({ basePath, disabled = false, isLocked }) => {
  const { watch, setValue } = useFormContext();
  const { t } = useTranslationApp();

  const storedWindow = watch(`${basePath}.attributionWindow`);
  const engagedView = watch(`${basePath}.attributionEngagedView`) === true;
  const attributionWindow = getIsValidMetaAttributionWindow(storedWindow)
    ? storedWindow
    : META_ATTRIBUTION_WINDOW_DEFAULT;
  const isDisabled = disabled || isLocked;

  const setField = (field, value) =>
    setValue(`${basePath}.${field}`, value, {
      shouldValidate: true,
      shouldDirty: true,
    });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="body1">
        {t(META_ATTRIBUTION_WINDOW_DESCRIPTION)}
      </Typography>

      <FormControl
        fullWidth
        variant="filled"
        hiddenLabel
        disabled={isDisabled}
        sx={{
          backgroundColor: "fields.background",
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
        }}
      >
        <SelectMUI
          hiddenLabel
          name={`${basePath}.attributionWindow`}
          value={attributionWindow}
          onChange={(e) => setField("attributionWindow", e.target.value)}
          sx={{
            borderRadius: 1,
            "& .MuiSelect-select": { display: "flex", alignItems: "center" },
          }}
        >
          {META_ATTRIBUTION_WINDOW_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.value === META_ATTRIBUTION_WINDOW_DEFAULT
                ? t(META_ATTRIBUTION_WINDOW_DEFAULT_OPTION, {
                    window: t(option.labelKey),
                  })
                : t(option.labelKey)}
            </MenuItem>
          ))}
        </SelectMUI>
      </FormControl>

      <Switch
        disabled={isDisabled}
        isActive={engagedView}
        labelActive={META_ATTRIBUTION_ENGAGED_VIEW_LABEL}
        labelDeactivate={META_ATTRIBUTION_ENGAGED_VIEW_LABEL}
        onChangeIsActive={(value) => {
          if (!getIsValidMetaAttributionWindow(storedWindow)) {
            setField("attributionWindow", attributionWindow);
          }
          setField("attributionEngagedView", value);
        }}
        sxLabel={{
          ".MuiFormControlLabel-label": { fontSize: "0.9rem", fontWeight: 400 },
        }}
      />
    </Box>
  );
};

export default AttributionWindowMeta;
